module.exports = __webpack_public_path__ + "static/media/Rimbayu-Starling Type D - 05-min.45a630ad.jpg";